'use strict';

var DataLoaderPanelDirective = function DataLoaderPanelDirective(DataLoaderPanelConstants) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/data-loader-panel.html'),
    scope: {
      status: '='
    },
    link: function link($scope) {
      $scope.getMessage = function () {
        switch ($scope.status) {
          case DataLoaderPanelConstants.LOADING:
            return 'Loading...';
          case DataLoaderPanelConstants.LOADED:
            return 'Loaded';
          case DataLoaderPanelConstants.NOT_FOUND:
            return 'No data found';
          case DataLoaderPanelConstants.ERROR:
            return 'Error retrieving data';
          default:
            return undefined;
        }
      };
    }
  };
};
DataLoaderPanelDirective.$inject = ['DataLoaderPanelConstants'];
module.exports = DataLoaderPanelDirective;